import { useState } from "react";
import {
  Avatar,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  Typography,
} from "@mui/material";
import {
  AppBarWrapper,
  OrganizationTypographyWrapper,
  ToolbarWrapper,
  UserContainerWrapper,
} from "./Styled";
import { Menu as MenuIcon, Logout, LockReset } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { logOutUser } from "features/auth/authSlice";
import { Loader } from "components/Loaders/Loader";
import { useGlobalContext } from "context/GlobalContext";
import { routeLinks } from "constants/paths";

export const TopBar = ({ toggleSideBarAction }) => {
  const [loading, setLoading] = useState(false);
  const { isMobile, unBoundMode, setUnBoundMode } = useGlobalContext();
  const { firstName, lastName, profilePicture } = useSelector(
    (state) => state.user.state
  );

  const companyDetails = useSelector((state) => state.companyAccess.state);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleUserMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };
  const logoutButtonHandler = async () => {
    Cookies.remove("Authorization");
    dispatch(logOutUser());
    navigate(routeLinks.authLogin);
  };
  return loading ? (
    <Loader />
  ) : (
    <>
      <AppBarWrapper position="fixed">
        <ToolbarWrapper>
          {/* Sidebar Toggle Button */}
          <IconButton
            edge="start"
            color="inherit"
            onClick={toggleSideBarAction}
          >
            <MenuIcon />
          </IconButton>

          {/* Organization Logo and Name */}
          <OrganizationTypographyWrapper variant="h4">
            <img src={companyDetails.companyLogo} alt="Logo" />
            {!isMobile && companyDetails.companyName}
          </OrganizationTypographyWrapper>

          {/* User Dropdown and Name */}
          <UserContainerWrapper>
            <Typography variant="body1">
              {!isMobile && firstName + " " + lastName}
            </Typography>
            <IconButton color="inherit" onClick={handleUserMenuOpen}>
              <Avatar alt={firstName} src={profilePicture} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleUserMenuClose}
            >
              <MenuItem onClick={() => navigate(routeLinks.authPasswordReset)}>
                <LockReset fontSize="small" />
                Reset Password
              </MenuItem>
              <MenuItem onClick={logoutButtonHandler}>
                <Logout fontSize="small" />
                Logout
              </MenuItem>
              <MenuItem
                onClick={() => setUnBoundMode(!unBoundMode)}
                style={{ textAlign: "center" }}
              >
                <FormControlLabel
                  control={<Switch checked={unBoundMode} />}
                  label="Unbound Mode"
                />
              </MenuItem>
            </Menu>
          </UserContainerWrapper>
        </ToolbarWrapper>
      </AppBarWrapper>
    </>
  );
};
